module.exports = __webpack_public_path__ + "static/media/end-overdose.b97d417f.PNG";